import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http'
import { environment } from '../../../environments/environment'
export const USE_API_KEY = new HttpContextToken<boolean>(() => true)
export const API_KEY = new HttpContextToken<string>(() => environment.apiKey)

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(USE_API_KEY)) {
    const modifiedRequest = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': req.context.get(API_KEY),
      },
    })
    return next(modifiedRequest)
  } else {
    return next(req)
  }
}
